module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('span', [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.loaded === 'true') ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h2', [_vm._v("LOCUTORES")]), _vm._v(" "), _vm._l((_vm.locutores), function(locutor) {
    return _c('div', {
      staticClass: "col-xs-6 col-md-3 locutor-item"
    }, [(locutor.better_featured_image !== null) ? _c('figure', [_c('img', {
      staticClass: "shadow",
      attrs: {
        "src": locutor.better_featured_image.media_details.sizes['530x626'].source_url,
        "alt": ""
      }
    })]) : _c('figure', [_c('img', {
      staticClass: "shadow",
      attrs: {
        "src": _vm.theme_url + '/html/assets/img/locutor.jpg',
        "alt": ""
      }
    })]), _vm._v(" "), _c('h4', {
      domProps: {
        "innerHTML": _vm._s(locutor.title.rendered)
      }
    }), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: 'locutor',
          params: {
            locutor: locutor.slug
          }
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\tVer Biografía\n\t\t\t\t\t\t\t")])], 1), _vm._v(" "), (typeof locutor.acf.programas == 'object') ? _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: 'programa',
          params: {
            elprograma: locutor.acf.programas[0].post_name
          }
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\tVer Programa\n\t\t\t\t\t\t\t")])], 1) : _vm._e()])])
  })], 2)]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9808f644"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/locutores.vue
// module id = 145
// module chunks = 0